import { useState, useEffect, useCallback } from 'react';

export const useMaxWidth = <T extends HTMLElement = HTMLDivElement>() => {
    const [node, setNode] = useState<T | null>(null);
    const [maxWidth, setMaxWidth] = useState(0);
    const [currentWidth, setCurrentWidth] = useState(0);

    const ref = useCallback((node: T) => {
        if (node !== null) {
            setNode(node);
        }
    }, []);

    useEffect(() => {
        if (!node) return;

        const updateWidth = () => {
            const width = node.getBoundingClientRect().width;
            setCurrentWidth(width);
            setMaxWidth((prevMax) => Math.max(prevMax, width));
        };

        // Инициализация
        updateWidth();

        // Создаем ResizeObserver для отслеживания изменений размера
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(node);

        // Очистка при размонтировании
        return () => {
            resizeObserver.disconnect();
        };
    }, [node]);

    return { ref, currentWidth, maxWidth };
};
